import { useEffect } from "react";
import { useSelector } from "react-redux";

const ZOHO_WIDGET_CODE = process.env.REACT_APP_ZOHO_WIDGET_CODE;

function ZohoChat() {
  const user = useSelector((state) => state.auth.user);
  const call = useSelector((state) => state.call);

  /**
   * 1️⃣ Load Zoho script ONCE
   */
  useEffect(() => {
    if (!ZOHO_WIDGET_CODE) return;

    // 🚫 Prevent multiple initializations
    if (window.$zoho?.salesiq || document.getElementById("zsiqscript")) return;

    window.$zoho = window.$zoho || {};
    window.$zoho.salesiq = {
      widgetcode: ZOHO_WIDGET_CODE,
      values: {},
      ready: function () {
        // 🔒 visitor may NOT be ready immediately
        if (!window.$zoho?.salesiq?.visitor) return;

        window.$zoho.salesiq.visitor.name(user?.name ?? "Guest User");
        window.$zoho.salesiq.visitor.email(
          user?.email ?? "guest@redvideochat.com"
        );
        window.$zoho.salesiq.visitor.contactnumber(
          user?.phone ?? "+919999999999"
        );
      },
    };

    const script = document.createElement("script");
    script.id = "zsiqscript";
    script.src = "https://salesiq.zohopublic.in/widget";
    script.async = true;
    document.body.appendChild(script);
  }, []); // 👈 load only once

  /**
   * 2️⃣ Update visitor details when user changes
   *    (wait until Zoho is really ready)
   */
  useEffect(() => {
    if (!user) return;

    const interval = setInterval(() => {
      if (window.$zoho?.salesiq?.visitor) {
        window.$zoho.salesiq.visitor.name(user?.name ?? "RED User");
        window.$zoho.salesiq.visitor.email(
          user?.email ?? "user@redvideochat.com"
        );
        window.$zoho.salesiq.visitor.contactnumber(
          user?.phone ?? "+919999999999"
        );

        clearInterval(interval); // ✅ stop once done
      }
    }, 300);

    return () => clearInterval(interval);
  }, [user]);

  /**
   * 3️⃣ Adjust Zoho widget position (mobile/desktop)
   */
  useEffect(() => {
    const interval = setInterval(() => {
      const iframe = document.querySelector('iframe[src*="salesiq"]');
      const float = document.getElementById("zsiq_float");

      const isMobile = window.innerWidth < 768;
      const bottomPosition = isMobile ? "60px" : "20px";
      const scaleValue = isMobile ? "0.7" : "0.7";

      [iframe, float].forEach((el) => {
        if (!el) return;

        el.style.position = "fixed";
        el.style.bottom = bottomPosition;
        el.style.right = "20px";
        el.style.zIndex = "40";
        el.style.transform = `scale(${scaleValue})`;
        el.style.transformOrigin = "bottom right";
      });
    }, 500);

    return () => clearInterval(interval);
  }, []);

  /**
   * 4️⃣ Hide Zoho during active calls
   */
  useEffect(() => {
    if (call?.status === "active") {
      document.body.classList.add("hide-zoho-chat");
    } else {
      document.body.classList.remove("hide-zoho-chat");
    }
  }, [call?.status]);

  return null;
}

export default ZohoChat;